import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/brand/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "@/pages/brand/Model"
import { CrudProvider } from "@/context/crudContext"
import { useState } from "react"
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs"

export default function BrandList() {
  const breadcrumbs = [{ label: "Dashboard", url: "/" }, { label: "Brand" }]

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Brands</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <BrandTable />
      </CrudProvider>
    </>
  )
}

function BrandTable() {
  return (
    <>
      <CustomTable label="Brands" columns={columns} apiPath="brand" />

      <Modal />
    </>
  )
}
